import {
    createBaseThemeOptions,
    createUnifiedTheme,
    genPageTheme,
    palettes,
    shapes,
  } from "@backstage/theme";
  
export const baseDarkTheme = createUnifiedTheme({
...createBaseThemeOptions({
    palette: {
        ...palettes.dark,
        mode: 'dark',
        text: {
          primary: "#fffbe5",
          secondary: "#d5d6db",
        },
        primary: {
            main: "#FFDD00",  // Cambia esto al amarillo para el header
            contrastText: "#0F265C"  // Texto azul oscuro para mejor contraste
        },
        background: {
          default: "#181a20",
          paper: "#23263a",
        },
        navigation: {
          background: "#23263a",
          indicator: "#fffbe5",
          color: "#fffbe5",
          selectedColor: "#ffea80",
          submenu: { background: '#343b58' },
          navItem: { hoverBackground: '#2a2d3e' }
        }
      },
    }),
    defaultPageTheme: "home",
    fontFamily: "Arial",
    pageTheme: {
      home:          genPageTheme({ colors: ['#23263a'], shape: shapes.wave }),
      documentation: genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      tool:          genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      service:       genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      website:       genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      library:       genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      other:         genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      app:           genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
      apis:          genPageTheme({ colors: ['#23263a'], shape: shapes.round }),
    },
});